import Model from "~/models/_Model";

export default class Connection extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "connections";
  }

  relations() {
    return {
      // task: Task,
    };
  }
}
